import "./LinkModal.scss";

function LinkModal({ title, onClose, children, size = "default" }) {
  return (
    <div className={`link-modal-content ${size !== "default" ? size : ""}`}>
      <div className="title">
        <span>{title}</span>
        <button className="close-button" onClick={onClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
      <div className="main-wrapper">{children}</div>
    </div>
  );
}

export default LinkModal;
